import React from 'react';
import { useTranslation } from 'react-i18next';
import ComponentLoader from '../ComponentLoader';

export const Suspense = ({ loaderMessage, component, loaderProps = {} }) => {
  const { t } = useTranslation();
  return (
    <React.Suspense fallback={<ComponentLoader {...loaderProps} message={typeof loaderMessage === 'string' ? t(loaderMessage) : loaderMessage} />}>{component}</React.Suspense>
  );
};
